import React, { Component } from "react"
import LazyLoadWrapper from "components/common/LazyLoadWrapper"
import ImagePlaceholder from "assets/images/imageplaceholder.png"
import "styles/components/common/certificate-card.scss"

const baseUrl = process.env.REACT_APP_CERTIFICATE_URL

class CertificateCard extends Component {
  viewCertificate = (address) => {
    if (address) {
      const url = `${baseUrl}/${address}`

      const newWindow = window.open(url, "_blank", "noopener,noreferrer")
      if (newWindow) newWindow.opener = null
    }
  }

  render() {
    const {
      data: { course, timestamp, image, school, address },
    } = this.props

    return (
      <div className="certificate-card">
        <div
          className="card-image"
          onClick={() => this.viewCertificate(address)}
        >
          <LazyLoadWrapper
            onError={(e) => (e.target.src = ImagePlaceholder)}
            src={`${image}`}
            effect="blur"
            width="100%"
            height="100%"
          />
        </div>
        <div className="card-content">
          <h2 className="card-title">{course}</h2>
          <p className="card-school">{school}</p>
          <p className="card-timestamp">Given: {timestamp}</p>
        </div>
      </div>
    )
  }
}

export default CertificateCard
